<template>
    <div class="houseStatisticalList" v-if="permisShow('房源统计')">
        <div class="tab">
            <div class="tab-item" @click="goto()">房源分析</div>
            <div class="tab-item tab-active">房源统计</div>
        </div>
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item time">
                    <span>日期</span>
                    <el-date-picker v-model="search.date" @change="queryHouseCustomerStatistic" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false"></el-date-picker>
                </li>
                <li class="conditions_list_item">
                    <span>查询类型</span>
                    <el-select v-model="search.queryType" @change="queryHouseCustomerStatistic" placeholder="不限">
                        <el-option v-for="(item,index) in typeList" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item" style="position:relative">
                    <span>{{searchTypeName}}</span>
                    <el-input @focus="departpopshow=!departpopshow" v-model="search.departmentName" placeholder="请选择所在部门" @clear="clearPerson" clearable></el-input>
                    <div class="departpop" v-show="departpopshow">
                        <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @clear="clearPerson" @node-click="handleNodeClick">
                            <span class="custom-tree-node" slot-scope="{ node,data}">
                                <div>
                                    <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                    <span>{{ data.name }}</span>
                                </div>
                            </span>
                        </el-tree>
                    </div>
                    <el-select v-if="search.queryType==2" v-model="search.employeeId" @clear="clearPerson" @change="queryHouseCustomerStatistic" placeholder="不限" clearable>
                        <el-option v-for="(item,index) in userList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item">
                    <span>房源类型</span>
                    <el-select v-model="search.houseType" @change="queryHouseCustomerStatistic" placeholder="不限" clearable>
                        <el-option v-for="(item,index) in housetypeList" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </li>
                <download-excel class="export-excel-wrapper" :data="List" :fields="search.queryType==2?changList1:changList" :name="excelName">
                    <el-button type="primary" style="background:#5E75E6;outline: none;border: none; ">导出</el-button>
                </download-excel>
            </ul>
        </div>

        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="List" border style="width: 100%" :header-cell-style="setHeaderStyle">
                <el-table-column prop="date" label="日期"></el-table-column>
                <el-table-column prop="department" label="部门"></el-table-column>
                <el-table-column prop="employeeName" label="姓名" v-if="search.queryType==2"></el-table-column>
                <el-table-column prop="houseAmount" label="房源数量"></el-table-column>
                <el-table-column prop="addHouseAmount" label="新增房源"></el-table-column>
                <el-table-column prop="addHouseFollow" label="新增跟进"></el-table-column>
                <el-table-column prop="addHouseLook" label="新增带看"></el-table-column>
                <el-table-column prop="addRealExploration" label="新增实勘"></el-table-column>
                <el-table-column prop="addHouseKey" label="新增钥匙"></el-table-column>
                <el-table-column prop="deal" label="成交"></el-table-column>
            </el-table>
            <div class="footer_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import { departmentFind, employeeQuery } from "@/api/manageCenter";
import { queryHouseCustomerStatistic } from "@/api/houseStatistical";
import { queryName } from "@/api";
export default {
    // name: "房源统计",
    name: "/houseStatisticalList",
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        let date = new Date();
        return {
            permisList,
            total: 0,
            currentPage: 1,
            pageNumber: 1, //从第几条开始
            pageSize: 20, //显示条数
            // state: "不限", //状态
            List: [], //房源列表
            imgListShow: false,
            curImgList: [],
            KeyStateList: [], //钥匙状态列表
            departpopshow: false,
            departmentList: [],
            defaultProps: {
                children: "child"
            },
            userList: [],
            typeList: [
                {
                    label: "部门",
                    value: 1
                },
                {
                    label: "人员",
                    value: 2
                }
            ],
            housetypeList: [
                {
                    label: "不限",
                    value: ""
                },
                {
                    label: "售房",
                    value: "SALE"
                },
                {
                    label: " 租房",
                    value: "RENT"
                }
            ],
            //搜索
            search: {
                date: [
                    date.getFullYear() + "-" + (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "-01",
                    date.getFullYear() + "-" + (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "-" + (date.getDate() >= 10 ? date.getDate() : '0' + date.getDate())
                ], //日期区间
                queryType: 1, //查询类型：部门:1/人员:2
                houseOrCustomer: 1,
                departmentId: "", //部门id
                employeeId: "", //员工id
                houseType: "", //房源类型
                permissionLevel: sessionStorage.getItem("permisListlevel") //权限级别
            },
            // 导出
            excelName: "房源统计列表",
            changList: {
                日期: "date",
                部门: "department",
                房源数量: "houseAmount",
                新增房源: "addHouseAmount",
                新增跟进: "addHouseFollow",
                新增带看: "addHouseLook",
                新增实勘: "addRealExploration",
                新增钥匙:"addHouseKey",
                成交: "deal",
            },
            changList1: {
                日期: "date",
                部门: "department",
                姓名:"employeeName",
                房源数量: "houseAmount",
                新增房源: "addHouseAmount",
                新增跟进: "addHouseFollow",
                新增带看: "addHouseLook",
                新增实勘: "addRealExploration",
                新增钥匙:"addHouseKey",
                成交: "deal",
            }
        };
    },
    components: {},
    mounted() {
        this.queryHouseCustomerStatistic();
        this.getdepartmentFindAll();
    },
    computed: {
        searchTypeName: function () {
            if (this.search.queryType == 1 || !this.search.queryType) {
                return "部门";
            } else {
                return "人员";
            }
        }
    },
    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            // console.log(23432343423, result);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },

        goto() {
            this.$router.push("houseStatistical");
        },

        getdepartmentFindAll() {
            // 获取部门
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },
        clearPerson() {
            this.search.departmentId = "";
            this.search.departmentName = "";
            this.queryHouseCustomerStatistic();
        },
        handleNodeClick(node, data) {
            //cosole.log(node)
            this.search.departmentId = node.id;
            this.search.departmentName = node.name;
            this.Getmessage();
            this.queryHouseCustomerStatistic();
            this.departpopshow = false;
        },

        Getmessage() {
            var params = {
                departmentId: this.search.departmentId,
                status:'ENABLE',
            };
            this.$post(employeeQuery, params).then(res => {
                if (res.success === true) {
                    this.userList = res.data;
                }
            });
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "总价";
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += " 元";
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },

        queryHouseCustomerStatistic() {
            let params = Object.assign({}, this.search);
            // console.log(213, params);
            params["page.pageSize"] = this.pageSize;
            params["page.pageNumber"] = (this.pageNumber - 1) * this.pageSize;
            this.$post(queryHouseCustomerStatistic, params).then(res => {
                if (res.success) {
                    this.List = res.data;
                    this.total = res.total;
                }
            });
        },

        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.queryHouseCustomerStatistic();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryHouseCustomerStatistic();
        },

        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        }
    }
};
</script>
<style type="text/css" lang="less">
.houseStatisticalList {
    background: #ffffff;
    margin: 20px 18px;
    padding: 22px 30px 10px;
    .tab {
        display: flex;
        align-items: center;
        &-item {
            width: 100px;
            height: 36px;
            font-size: 14px;
            line-height: 36px;
            background: #f1f1f1;
            text-align: center;
            cursor: pointer;
        }
        &-active {
            background: #ff9065;
            color: #ffffff;
        }
    }
    .departpop {
        width: 170px;
        position: absolute;
        left: 60px;
        top: 41px;
        z-index: 10;
        border: 1px solid #eee;
        .tree-item {
            display: flex;
            align-items: center;
            img {
                padding-right: 10px;
            }
        }
    }
    .key_list {
        display: flex;
        .conditions_list_item {
            background: #f5f5f5;
            padding: 0 10px;
            display: flex;
            align-items: center;
            margin-right: 20px;
            position: relative;
            // overflow: hidden;
            cursor: pointer;
            > span {
                border-right: 1px solid #ccc;
                font-size: 12px;
                color: #5e75e6;
                padding: 4px 10px 4px 0;
            }
            .el-date-editor {
                background: #f5f5f5;
                margin-left: 10px;
                width: 310px;
                height: 30px;
                line-height: 30px;
                border: none;
                .el-range-input {
                    line-height: 30px;
                    background: #f5f5f5;
                    height: 30px;
                    border: none;
                    color: black;
                    padding-left: 30px;
                }
                .el-input__icon {
                    height: 30px;
                    line-height: 30px;
                }
                .el-range-separator {
                    height: 30px;
                    line-height: 30px;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 70px;
                    .el-input__inner {
                        width: 60px;
                        height: 30px;
                        border: none;
                        background: #f5f5f5;
                        color: black;
                        padding: 0;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .el-input {
                s .el-input__inner {
                    height: 30px;
                    border: none;
                    background: #f5f5f5;
                    color: black;
                }
                .el-input__icon {
                    height: 30px;
                    line-height: 30px;
                }
            }
        }
    }
    .el-table .cell,
    .el-table th div,
    .el-table--border td:first-child .cell,
    .el-table--border th:first-child .cell {
        text-align: center;
    }

    .key_top {
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // padding: 0 30px;
        background: #fff;
        .el-input {
            width: 145px;
            height: 30px;

            .el-input-group__append,
            .el-input-group__prepend {
                padding: 0 10px;
                background: #cccccc;
                border: none;
            }

            .el-input__inner {
                border: none;
                height: 30px;
                background: #f5f5f5;
            }

            .icon-icon_sousuo {
                color: white;
            }
        }

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }

        //弹出框样式
        .el-dialog {
            width: 500px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }
    }

    .key_list_wrap {
        height: 90%;

        .el-dialog {
            width: 600px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }

        .footer_page {
            position: relative !important;
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }
        }
    }

    .mask .el-carousel__item {
        background: transparent;
        opacity: 1!important;
    }
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 9;
        .close {
            width: 20px;
            position: absolute;
            top: 0;
            right: 300px;
            padding: 50px;
            z-index: 100;
        }
        .delet {
            position: absolute;
            padding-left: 36px;
            padding-right: 36px;
            bottom: 0;
            right: 100px;
            z-index: 100;
            height: auto !important;
        }
        .edit {
            position: absolute;
            padding-left: 36px;
            padding-right: 36px;
            bottom: 0;
            right: 240px;
            z-index: 100;
            height: auto !important;
        }

        .el-carousel__container {
            width: 80%;
            margin: 200px auto;
            height: 100%;
            z-index: 99;
            .el-carousel__arrow {
                font-size: 50px !important;
                padding: 20px;
                width: 100px;
                height: 100px;
            }
            // .el-carousel__arrow--left,.el-carousel__arrow--right{

            // }
        }

        .el-carousel__item {
            color: #475669;
            font-size: 18px;
            opacity: 0.75;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            // min-height: 400px;
            .uploadtime {
                width: 100%;
                line-height: 24px;
                color: #fff;
                position: absolute;
                left: 100px;
                bottom: 0;
            }
            > img {
                width: 90%;
            }
        }
        .door_modle_introduced {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            padding: 0 100px;
            .introduced_toward {
                display: flex;
                flex-direction: column;
                > span {
                    font-size: 14px;
                    color: #ffffff;
                }

                .el-textarea {
                    margin-top: 10px;
                    .el-textarea__inner {
                        width: 260px;
                        height: 60px;
                        background: #f5f5f5;
                        border: 1px solid #ccc;
                    }
                }
            }
            .el-select {
                margin-top: 10px;
                .el-input {
                    .el-input__inner {
                        padding-left: 10px !important;
                        font-size: 16px !important;
                        width: 100px !important;
                        height: 30px !important;
                        line-height: 30px !important;
                        background: #f5f5f5;
                        border: 1px solid #ccc !important;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
        }

        // .el-carousel__item:nth-child(2n) {
        //   background-color: #99a9bf;
        // }

        // .el-carousel__item:nth-child(2n+1) {
        //   background-color: #d3dce6;
        // }
    }
}
</style>
